import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { canManageKarkhana } from "../../../helpers/karkhanaEnabled";
import { getProductCosting } from "../../../services/karkhanaApi";
import { rupees } from "../rates/rateModel";
import { STATUS_LABEL } from "./costingModel";
import { kp } from "../karkhanaPaths";

const readRole = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "null")?.users?.role;
  } catch {
    return undefined;
  }
};

/**
 * Under the product's cost and sale price: where those prices come from. Shows the saree's costing
 * (or the costing of the saree this product is a variant of) with a link to its details. Owner/admins
 * and managers with Karkhana only; nothing for products that aren't a Karkhana saree.
 */
const ProductCostingLink = ({ productUniqueId }: { productUniqueId?: string }) => {
  const role = readRole();
  const allowed = canManageKarkhana(role);
  const [data, setData] = useState<any>(null);
  // Same as the price fields above: amounts stay hidden until someone asks to see them.
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!allowed || !productUniqueId) return;
    let live = true;
    getProductCosting(productUniqueId)
      .then((res: any) => live && res?.success && setData(res.data))
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [allowed, productUniqueId]);

  if (!allowed || !data?.sareeNumber) return null;
  const a = data.approved;
  const o = data.open;
  const target = o || a;
  return (
    <div className="hkp-product-costing">
      <span>
        <strong>Costing</strong> · saree {data.sareeNumber}
        {data.viaVariant ? " (this is a variant)" : ""}
        {a ? (
          shown ? (
            <>
              {" "}
              · approved v{a.versionNo}: cost {rupees(a.costPrice, 0)} · sale {rupees(a.salePrice, 0)}
              {a.marginPct ? ` · margin ${a.marginPct}%` : ""}
            </>
          ) : (
            <>
              {" "}
              · approved v{a.versionNo} ·{" "}
              <button type="button" className="hkp-product-costing__reveal" onClick={() => setShown(true)}>
                Show amounts
              </button>
            </>
          )
        ) : null}
        {o ? ` · v${o.versionNo} ${String(STATUS_LABEL[o.status] || o.status).toLowerCase()}` : ""}
        {!a && !o ? " · not done yet" : ""}
      </span>
      <Link to={target ? kp.costing(target.id) : kp.costings({ saree: data.sareeNumber })}>
        {target ? "See costing details ›" : "Start costing ›"}
      </Link>
    </div>
  );
};

export default ProductCostingLink;
